import React from "react";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../../Utils/renderField/renderReadField";

const CAMPOS = [
    {
        clave: "kg_secos_laboratorio",
        etiqueta: "Total lab. kg secos",
        tipo: "kg",
    },
    {
        clave: "kg_secos_produccion",
        etiqueta: "Total prod. kg secos",
        tipo: "kg",
    },
    { clave: "diferencia_kg", etiqueta: "Dif. prod. vrs lab.", tipo: "kg" },
    {
        clave: "diferencia_porcentaje",
        etiqueta: "% dif. prod. vrs lab.",
        tipo: "porcentaje",
    },
];

const ValorComparativo = ({ tipo, valor }) => {
    if (tipo === "porcentaje") {
        // sin kg secos del laboratorio no hay contra qué comparar
        if (valor === null) {
            return (
                <input
                    type="text"
                    className="form-control"
                    disabled
                    value="Pendiente"
                />
            );
        }

        return (
            <RenderNumberPercentage
                className="form-control disabled-input"
                value={valor}
                decimalScale={2}
            />
        );
    }

    return (
        <RenderKilogramo
            className="form-control disabled-input"
            value={valor}
            decimalScale={2}
        />
    );
};

// Los kg secos que midió el laboratorio en las tancadas contra los que produjo
// el turno
export const ComparativoProduccion = ({ comparativo }) => (
    <div className="formulario-fields-row gap-1rem mt-2 mb-4 flex-wrap">
        {CAMPOS.map((campo) => (
            <div className="formulario-field min-w-150" key={campo.clave}>
                <label className="text-nowrap">{campo.etiqueta}</label>
                <ValorComparativo
                    tipo={campo.tipo}
                    valor={comparativo[campo.clave]}
                />
            </div>
        ))}
    </div>
);
